import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {TdoUserConfigurationModel} from '../../../models/configuration/user/tdo-user-configuration.model';
import {UserService} from '../../../services/user.service';
import {SignalrService} from '../../../services/socket/signalr.service';
import {Globals} from '../../../globals';
import {version, appName} from '../../../../environments/version';
import {AuthenticationResponseModel} from '../model/authentication-response.model';
import {AuthenticationService} from '../services/authentication.service';
import {LoginService} from '../login/login.service';
import {DoctorsService} from '../../../services/doctors.service';
import {LocalStorageService} from '../../../services/local-storage.service';
import {TdoImagingService} from '../../../main-interface/imaging/tdo-imaging.service';

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss']
})
export class LoginPageComponent implements OnInit {
  private returnUrl: string;
  returnParams: any = false;

  appVersion: string = '';
  appName: string = '';
  invalidCredentials:boolean=false;

  //public frmCtrl = new UntypedFormControl('');

  public loadingLocations: boolean = true;
  public locations: any[] = [];
  public selectedLocation: string;
  public userName: any;
  public password: any;
  public userEmail: any;
  public validated: boolean = false;
  public isLoading: boolean = false;
  public error = '';
  public loginMode : boolean = true;
  public passwordResetTokenAvailable: boolean = false;
  public passwordResetToken: string = '';
  public passwordResetConfirmation: boolean = false;
  public showChangeMessage: boolean = false;
  public passwordChange: string = '';
  public passwordConfirmation: string = '';
  public passwordChangeMessage: string = '';
  public fieldTextType:boolean = false;
  public requestResetPasswordMessage: string ='';

  constructor(private readonly route: ActivatedRoute,
              private readonly router: Router,
              private readonly globals: Globals,
              private readonly userService: UserService,
              private readonly doctorService: DoctorsService,
              private readonly loginService: LoginService,
              private readonly authService: AuthenticationService,
              private readonly localStorageService: LocalStorageService,
              private readonly drawService: TdoImagingService,
              private readonly signalrService: SignalrService) { }

  ngOnInit() {
    this.appVersion = version;
    this.appName = appName;
console.log('app local version: ', version);
    if (this.route.queryParams) {
      this.route.queryParams.subscribe(params  => {
        this.passwordResetToken = params['pct'];
        if (this.passwordResetToken) {
          this.passwordResetTokenAvailable = true;
        }
      });
    }

    if (localStorage.getItem('returnURL')) {
      this.returnUrl = localStorage.getItem('returnURL');
      localStorage.removeItem('returnURL');
    } else {
      this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';
    }

    if (localStorage.getItem('returnURLParameters')) {
      this.returnParams = JSON.parse(localStorage.getItem('returnURLParameters'));
      localStorage.removeItem('returnURLParameters');
    }

    this.loadLocations();


    if (typeof localStorage.getItem('LOCID') != 'undefined') {
      this.selectedLocation = localStorage.getItem('LOCID');
    }
    // get ws mac address from service broker

    this.isServiceBrokerRunning();

  }

  loadLocations(){
    this.loginService.getLocations()
    .subscribe(response => {
      response.forEach(location => {
        location.LOCID = `${location.LOCID}`
      });
      this.locations = response;
      this.loadingLocations = false;
    }, err => {
      console.log('getLocations error:', err);
      this.loadingLocations = false;
      setTimeout(() => {this.loadLocations();}, 1000);
    });
  }
  isServiceBrokerRunning() {
    this.drawService.isServiceBrokerRunning(() => {
      const intervalSubscription = setInterval(_ => {
        if (this.drawService.isSBRunning === true) {
          clearInterval(intervalSubscription);
          this.drawService.getWSNameWithMacAddress(() => {
            const intervalSubscription2 = setInterval(_ => {
              if (this.drawService.wsNameWithMACAddress !== '') {
                clearInterval(intervalSubscription2);
                this.globals.WorkStationName = this.drawService.wsNameWithMACAddress;
              }
            }, 100);
          });
        } else {
          clearInterval(intervalSubscription);
          this.globals.WorkStationName = 'WSTEST';
          console.log('Service Broker is not running using default workstaion name WSTEST');
        }
      }, 100);
    });
  }

  locationSelected(event) {
    localStorage.setItem('LOCID', `${event}`);
  }

  loginUser() {

    this.isLoading = true;
    this.invalidCredentials = false;

    this.authService.loginJwt(this.userName, this.password, this.selectedLocation, this.globals.WorkStationName)
      .subscribe((dataAuth: AuthenticationResponseModel) => {
        this.isLoading = false;
        if (dataAuth.isSuccess) {

          this.globals.LOCenumCountryId = dataAuth.locationCountryId;
          this.globals.showSuburbInAddress = this.globals.LOCenumCountryId !== '00000007-1000-0000-0000-000000000001'; // show if not  usa


          this.authService.storetokenResult(dataAuth);
          this.validated = true;

          this.setLoggedInUser(dataAuth);
          this.signalrService.connect();

          this.doctorService.checkIfUserIsDoctor(dataAuth.userId).subscribe((res) => {
            if (res) {
              this.localStorageService.loggedInDoctorId = res.DoctorId;
            }
            if (this.returnParams) {
              this.router.navigate([this.returnUrl], { queryParams: this.returnParams });
            } else {
              this.router.navigate([this.returnUrl]);
            }
          });
        } else {
          this.error = 'invalid login';
          console.log('login error: ', this.error);
          this.invalidCredentials = true;
        }
      },
        (error) => {
          this.isLoading = false;
          console.log('error: ' + error.message);
          this.error = error;
          this.invalidCredentials = true;
        });
  }

  requestResetPassword() {
    this.isLoading = true;
    this.invalidCredentials = false;

    this.authService.resetPasswordRequest(this.userName, this.userEmail, this.globals.WorkStationName)
      .subscribe((dataAuth: AuthenticationResponseModel) => {
        this.isLoading = false;
        if (dataAuth.isSuccess) {
          this.requestResetPasswordMessage = 'If user is found, you will receive an email with login instructions.';
          this.showChangeMessage = true;
        }
      },
        (error) => {
          this.isLoading = false;
          console.log('error: ' + error.message);
          this.error = error;
          this.requestResetPasswordMessage = 'Error requesting password reset. Please try again later.';
          this.showChangeMessage = true;
        });
  }

  resetPassword() {
    this.isLoading = true;
    this.invalidCredentials = false;
    this.authService.resetPassword(this.passwordResetToken, this.passwordChange, this.passwordConfirmation)
      .subscribe((dataAuth: AuthenticationResponseModel) => {
        this.isLoading = false;
        if (dataAuth.isSuccess) {
          this.passwordResetConfirmation = true;
        }
        else{
          this.passwordResetConfirmation = false;
          if (dataAuth.message.endsWith('.'))
            dataAuth.message = dataAuth.message.substring(0, dataAuth.message.length - 1);
          this.passwordChangeMessage = `Password change failed. Please try again. <br/><li>${dataAuth.message.replaceAll('.', '<li>')}`;
        }

      },
        (error) => {
          this.isLoading = false;
          console.log('error: ' + error.message);
          this.error = error;
          this.invalidCredentials = true;
        });
  }

  private setLoggedInUser(dataAuth: AuthenticationResponseModel) {
    this.userService.loggedInUser = new TdoUserConfigurationModel();
    this.userService.loggedInUser.userid = dataAuth.userId;
    this.userService.loggedInUser.UserID = dataAuth.userId;
    this.userService.loggedInUser.WorkStationID = dataAuth.workStationId;
    this.globals.WorkStationID = dataAuth.workStationId;
    this.userService.loggedInUser.TDOCID = Number(dataAuth.tdoCId);
    this.userService.loggedInUser.UserNickName = dataAuth.userNickName;
  }

  forgotPasswordClicked(): void {
    this.userName = '';
    this.password = '';
    this.userEmail = '';
    this.loginMode = false;
    this.passwordResetTokenAvailable = false;
    this.passwordResetConfirmation = false;
    this.passwordResetToken ='';
    this.passwordChangeMessage='';
    this.showChangeMessage = false;
    this.requestResetPasswordMessage='';

  }

  showLogin(){
    this.userName = '';
    this.password = '';
    this.userEmail = '';
    this.passwordChangeMessage='';
    this.loginMode = true;
    this.passwordResetTokenAvailable = false;
    this.passwordResetConfirmation = false;
    this.showChangeMessage = false;
    this.passwordResetToken ='';
    this.requestResetPasswordMessage='';
    this.router.navigate(['/login']);
  }

  tdoReferrerClicked(): void {
    this.router.navigateByUrl(`/referrerLogin`);
  }
  tdoPatientClicked(): void {
    this.router.navigateByUrl(`/patientLogin`);
  }

  showPasswords(){
    this.fieldTextType = true;
  }

  hidePasswords(){
    this.fieldTextType = false;
  }
}
